module.exports = __webpack_public_path__ + "static/media/RKBrowser6w1442@2x.4c9cbd5b.jpg";